export const ORDER_OF_CATEGORIES: {
  [key: string]: number;
} = {
  General: 1,
  Environment: 2,
  Social: 3,
  Governance: 4,
};
